import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/professional-bio-generator/BioGeneratorContent.tsx");
